import { render, staticRenderFns } from "./block-list-view-item.vue?vue&type=template&id=6b4ab80c&scoped=true"
import script from "./block-list-view-item.vue?vue&type=script&lang=js"
export * from "./block-list-view-item.vue?vue&type=script&lang=js"
import style0 from "./block-list-view-item.vue?vue&type=style&index=0&id=6b4ab80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ab80c",
  null
  
)

export default component.exports